import { lazy } from 'react';

// Login
const SignIn = lazy(() => import('./pages/landing/SignIn/SignIn'));
const SignUp = lazy(() => import('./pages/landing/SignUp/SignUp'));

// Home
// const Home = lazy(() => import('./pages/home/Home/Home'));

// Configuration
const Config = lazy(() => import('./pages/config/Config/Config'));
const Profile = lazy(() => import('./pages/config/Profiles/Profiles'));

// Documents
const Documents = lazy(() => import('./pages/documents/Documents/Documents'));
const UploadPurchase = lazy(() => import('./pages/documents/UploadPurchase/UploadPurchase'));
const UploadSale = lazy(() => import('./pages/documents/UploadSale/UploadSale'));
const UploadPosSale = lazy(() => import('./pages/documents/UploadPosSale/UploadPosSale'));
const EditPurchase = lazy(() => import('./pages/documents/EditPurchase/EditPurchase'));
const EditSale = lazy(() => import('./pages/documents/EditSale/EditSale'));
const EditPosSale = lazy(() => import('./pages/documents/EditPosSale/EditPosSale'));

//suppliers
const Suppliers = lazy(() => import('./pages/suppliers/Suppliers/Suppliers'));
const Supplier = lazy(() => import('./pages/suppliers/Supplier/Supplier'));
const addSupplier = lazy(() => import('./pages/suppliers/AddSupplier/AddSupplier'));

//Invoices
const Invoices = lazy(() => import('./pages/invoices/Invoices/Invoices'));

//Integration Contability
const IntegracionContable = lazy(() => import('./pages/accounting/AccountingIntegration/AccountingIntegration'));

//Payouts
const Payouts = lazy(() => import('./pages/payments/Payout/Payout'));

// Payroll
const Payrolls = lazy(() => import('./pages/payroll/Payrolls/Payrolls'));
const Payroll = lazy(() => import('./pages/payroll/Payroll/Payroll'));
const PayrollPayout = lazy(() => import('./pages/payroll/Payout/Payout'));

// Collaborators
const Collaborators = lazy(() => import('./pages/collaborators/Collaborators/Collaborators'));
const AddCollaborators = lazy(() => import('./pages/collaborators/AddCollaborator/AddCollaborator'));
const Collaborator = lazy(() => import('./pages/collaborators/Collaborator/Collaborator'));

// Callbacks
const PaymentConnection = lazy(() => import('./pages/callbacks/PaymentConnection/PaymentConnection'));
const PSECallbackPay = lazy(() => import('./pages/callbacks/PSECallback/PSECallback'));

//FillOutInvoices
const FillOutInvoices = lazy(() => import('./pages/FillOutInvoices/FillOutInvoices/FillOutInvoices'));

//PayAgreements
const PayAgreements = lazy(() => import('./pages/payAgreements/PayAgreements'));

//paymentHistory
const PaymentHistory = lazy(() => import('./pages/paymentHistory/PaymentHistory'));

//completeRegister
const CompleteRegister = lazy(() => import('./pages/completeRegister/CompleteRegister'));

//pay
const Pay = lazy(() => import('./pages/pay/Pay'));

//charge
const Charge = lazy(() => import('./pages/charge/Charge'));
const AddClient = lazy(() => import('./pages/charge/MyClient/AddClient/AddClient'));
const Client = lazy(() => import('./pages/charge/MyClient/InfoClient/InfoClient'));
const GenerateCharge = lazy(() => import('./pages/generateCharge/GenerateCharge'));

//help
const Help = lazy(() => import('./pages/help/Help'));

//help
const Agreements = lazy(() => import('./pages/agreements/Agreements'));

//product
const Product = lazy(() => import('./pages/agreements/Product/Product'));

export const paths = {
  root: '/',
  login: '/login',
  signup: '/register',
  home: '/dashboard',
  config: '/configcompany',
  profiles: '/configProfile',
  documents: '/documents',
  uploadPurchase: '/upload-purchase',
  uploadSale: '/upload-sale',
  uploadPosSale: '/upload-possale',
  editPurchase: '/edit-purchase/:documentId',
  editSale: '/edit-sale/:documentId',
  editPosSale: '/edit-possale/:documentId',
  suppliers: '/itemssuppliers',
  supplier: '/itemsupplier/:supplierId',
  emailCallback: '/email-integration-callback',
  invoices: '/invoices',
  integrationCont: '/integracionContable',
  payout: '/payout',
  payrolls: '/payrolls',
  payroll: '/payroll/:id',
  payrollPayout: '/payroll-payout',
  collaborators: '/collaborators',
  addCollaborators: '/addCollaborators',
  collaborator: '/collaborator/:collaboratorId',
  addSupplier: '/addSupplier',
  paymentConnection: '/payment-connection/:type/:oldDruoAccountId',
  fillOutInvoices: '/fillOutInvoices',
  payAgreements: '/payAgreements',
  paymentHistory: '/paymentHistory',
  PSECallbackPay: '/pse-callback/:payoutId',
  completeRegister: '/completeRegister',
  pay: '/pay',
  charge: '/charge',
  addClient: '/addClient',
  client: '/client/:clientId',
  help: '/help',
  agreements: '/agreements',
  generateCharge: '/generateCharge',
  product: (productId = ':productId') => `/product/${productId}`,
};

const routes = {
  landing: [
    { path: paths.login, Component: SignIn, title: 'Iniciar sesión' },
    { path: paths.signup, Component: SignUp, title: 'Registro' }
  ],
  platform: [
    // { path: paths.home, Component: Home, title: 'Dashboard' },
    { path: paths.config, Component: Config, title: 'Configuración' },
    { path: paths.profiles, Component: Profile, title: 'Perfil' },
    { path: paths.documents, Component: Documents, title: 'Documentos' },
    { path: paths.uploadPurchase, Component: UploadPurchase, title: 'Recibo de compra' },
    { path: paths.uploadSale, Component: UploadSale, title: 'Recibo de venta' },
    { path: paths.uploadPosSale, Component: UploadPosSale, title: 'Consolidado de venta POS' },
    { path: paths.editPurchase, Component: EditPurchase, title: 'Recibo de compra' },
    { path: paths.editSale, Component: EditSale, title: 'Recibo de venta' },
    { path: paths.editPosSale, Component: EditPosSale, title: 'Consolidado de venta POS' },
    { path: paths.suppliers, Component: Suppliers, title: 'Proveedores' },
    { path: paths.supplier, Component: Supplier, title: 'Proveedor' },
    { path: paths.product(), Component: Product, title: 'Proveedor' },
    { path: paths.invoices, Component: Invoices, title: 'Recibos' },
    { path: paths.integrationCont, Component: IntegracionContable, title: 'Reportes', globalLoading: false },
    { path: paths.payout, Component: Payouts, title: 'Pagar', isFlow: true },
    { path: paths.payrolls, Component: Payrolls, title: 'Nóminas' },
    { path: paths.payroll, Component: Payroll, title: 'Nómina' },
    { path: paths.payrollPayout, Component: PayrollPayout, title: 'Pagar colaboradores', isFlow: true },
    { path: paths.collaborators, Component: Collaborators, title: 'Colaboradores' },
    { path: paths.addCollaborators, Component: AddCollaborators, title: 'Agregar colaborador', isFlow: true },
    { path: paths.collaborator, Component: Collaborator, title: 'Colaboradores' },
    { path: paths.addSupplier, Component: addSupplier, title: 'Agregar proveedor', isFlow: true },
    { path: paths.addClient, Component: AddClient, title: 'Agregar Cliente', isFlow: true },
    { path: paths.client, Component: Client, title: 'Cobros' },
    {
      path: paths.paymentConnection,
      Component: PaymentConnection,
      title: 'Conexión bancaria',
      basePath: 'payment-connection',
      showFirstModals: false
    },
    { path: paths.fillOutInvoices, Component: FillOutInvoices, title: 'Diligenciar cuenta de cobro', isFlow: true },
    { path: paths.payAgreements, Component: PayAgreements, title: 'Pagar', isFlow: true },
    { path: paths.paymentHistory, Component: PaymentHistory, title: 'Historial' },
    { path: paths.PSECallbackPay, Component: PSECallbackPay, title: 'Pago PSE', basePath: 'pse-callback', showFirstModals: false },
    { path: paths.completeRegister, Component: CompleteRegister, title: 'Completa tus datos', isFlow: true },
    { path: paths.pay, Component: Pay, title: 'Pagos' },
    { path: paths.charge, Component: Charge, title: 'Cobros' },
    { path: paths.help, Component: Help, title: 'Ayuda' },
    { path: paths.agreements, Component: Agreements, title: 'Servicio' },
    { path: paths.generateCharge, Component: GenerateCharge, title: 'Cobrar', isFlow: true }
  ]
};

export default routes;
